import "./App.css";
import AppRoutes from "./components/AppRoutes";

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
